import { API_MAP, agent } from 'helpers';
class AffiliateService {
  static listAffiliates(pagination: any, status: 'pending' | 'approved' | 'reproved', order: string | null, coproducer: boolean = false) {
    let orderBy = '';
    if (order) {
      orderBy = '&orderby=' + order;
    }

    let coproducerQueryStringParam = '';
    if (coproducer) {
      coproducerQueryStringParam = '&coproducer=true';
    }

    return agent.get(
      `${API_MAP.listAffiliates}?per_page=${pagination.per_page}&page=${pagination.page}&status=${status}${orderBy}${coproducerQueryStringParam}`
    );
  }

  static getPendingAffiliatesSummary(format: 'count' | 'list', force?: boolean) {
    let standard = `${API_MAP.getPendingAffiliatesSummary}`
    if(format && force) return agent.get(`${standard}?format=${format}&cache_clear=true`);
    if(format) return agent.get(`${standard}?format=${format}`);
    return agent.get(`${standard}`)
  }

  static configCustomCommission(affiliateId: any, type: any, value: any) {
    return agent.post(`${API_MAP.configCustomCommission}`.replace('{id}', affiliateId), { type, value });
  }

  static moderateAffiliate(affiliateId: any, status: any) {
    return agent.post(`${API_MAP.moderateAffiliate}`.replace('{id}', affiliateId), { status });
  }

  static moderateMultipleAffiliates(affiliatesIds: Array<number>, status: 'A' | 'R') {
    return agent.put(API_MAP.moderateMultipleAffiliates, { affiliates: affiliatesIds, status });
  }

  static exportAffiliates(status: 'pending' | 'approved' | 'reproved', order: string | null) {
    let orderBy = '';
    if (order) {
      orderBy = '&orderby=' + order;
    }
    return agent.get(`${API_MAP.listAffiliates}?status=${status}${orderBy}&coproducer=true&export=true`, {
      responseType: 'blob',
    });
  }
}
export default AffiliateService;
